import { useParams } from "react-router-dom";
import { useGetExamBaseQuery, useGetTimeSlotQuery } from "../../../api";
import "./index.scss";
import LoadingTakeover from "../../buffers/LoadingTakeover";
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import formatTimeZoneDateString from "../../utilities/formatTimeZoneDate";
import formatTime from "../../utilities/fromatTime";
import { usePostScheduledTesterMutation, usePostExamConfirmationEmailMutation } from "../../../api";
import { useSystemMessage } from "../../../providers/SystemMessageContext";
import sendExamConfirmationEmail from "../../helpers/sendExamConfirmationEmail";
import { useNavigate } from "react-router-dom";

const ReservationPipeline = () => {
    const { showMessage } = useSystemMessage();
    const navigate = useNavigate();

    const { time_slot_id } = useParams();
    const { data, loading, error } = useGetExamBaseQuery();
    const { data:timeslotData, loading:timeslotLoading, error: timeslotError } = useGetTimeSlotQuery(time_slot_id)

    const { submit: submitScheduledTester, error: submitScheduledTesterError, data: createdScheduledTester, loading: createLoading } = usePostScheduledTesterMutation();
    const handleSubmitScheduledTester = async () => {
        const payload = {
            add_tester: {
                time_slot_id: time_slot_id,
                exam_title: selectedExam,
                notes: [selectedExam, position, location].join(',')
            }
        }
        await submitScheduledTester(payload).catch((error) => {
            return;
        })
        return;
    };

    const { submit: sendExamConfirmationEmail, error: emailSendError, loading: emailSendig } = usePostExamConfirmationEmailMutation();
    const handleSendExamConfirmationEmail = async (time_slot_id: number, test_taker_id:number) => {
        const payload = {
            timeslot_id: time_slot_id,
            test_taker_id: test_taker_id
        }
        await sendExamConfirmationEmail(payload)
        .then((response) => {
            navigate('/schedule');
        })
        .catch((error) => {
            return;
            navigate('/schedule');
        })
        .finally(() => {
            navigate('/schedule');
        })
        return;
    };

    useEffect(() => {
        if (createLoading) return;
        if (submitScheduledTesterError) {
            showMessage(submitScheduledTesterError.response.data.message, submitScheduledTesterError.response.data.success ? "success" : "error")
        } else if (createdScheduledTester && time_slot_id) {
            showMessage(createdScheduledTester.message, createdScheduledTester.success ? "success" : "error")
            setSendEmail(true);
        }
    }, [createdScheduledTester, submitScheduledTesterError]);

    const [sendEmail, setSendEmail] = useState(false);
    useEffect(() => {
        if (!sendEmail) return;
        handleSendExamConfirmationEmail(parseInt(createdScheduledTester.data[0].time_slot), createdScheduledTester.data[0].test_taker);
    }, [sendEmail, time_slot_id])

    const [selectedExam, setSelectedExam] = useState(null);
    const handleChangeExam = (e:any) => {
        setSelectedExam(e.target.value)
    };

    const [position, setPosition] = useState(null);
    const handleChangePosition = (e:any) => {
        setPosition(e.target.value);
    };

    const [location, setLocation] = useState(null);
    const handleChangeLocation = (e:any) => {
        setLocation(e.target.value);
    };

    const [canSubmit, setCanSubmit] = useState(false);
    useEffect(() => {
        if (!(position && selectedExam && location)) return;
        setCanSubmit(true);
    }, [position, selectedExam, location]);

    if (loading || timeslotLoading) {
        return (
            <LoadingTakeover />
        )
    } else if (data && timeslotData) {
        return (
            <div className='res-pipe'>
                <div className="header">
                    <Typography sx={{mb:1, color:'#054fb9', fontWeight:700, textAlign:'left'}} variant="h4">Reservation Questionnaire</Typography>
                    <p>
                        Please answer the following questions to confirm your reservation on {formatTimeZoneDateString(timeslotData.data[0].exam_date_date)}, {formatTime(timeslotData.data[0].start_time)} - {formatTime(timeslotData.data[0].end_time)}.
                    </p>
                </div>
                <div className="body">
                    <h5>
                        Which exam are you taking?
                    </h5>
                    <FormControl>
                        <FormLabel></FormLabel>
                        <RadioGroup>
                            {data.data.map((d:any) => {
                                return <FormControlLabel key={d.id} value={d.exam_title} label={d.exam_title} control={<Radio />} onChange={handleChangeExam}/>
                            })}
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className="body">
                    <h5>
                        What is the name of the position you are applying to?
                    </h5>
                    <TextField label='Position Name' variant="outlined" sx={{width:'100%'}} value={position} onChange={handleChangePosition} required={true}/>
                </div>
                <div className="body">
                    <h5>
                        Which school site or location you are applying to?
                    </h5>
                    <TextField label='School Site or Loaction' variant="outlined" sx={{width:'100%'}} value={location} onChange={handleChangeLocation} required={true}/>
                </div>
                <div className="footer">
                    <Button variant="contained" disabled={!canSubmit} onClick={handleSubmitScheduledTester}>
                        Submit
                    </Button>
                </div>
            </div>
        )
    }

};

export default ReservationPipeline;